import type { BodyGene } from '@/domain/genetics/types';
import type { ActorFootprint } from './geometry';

export type WorldFacing = 'down' | 'up' | 'left' | 'right';
export type LocomotionState = 'idle' | 'walk';

const MOVEMENT_EPSILON = 0.01;

const BODY_WIDTH_RATIO: Record<BodyGene, number> = {
  round: 0.3,
  tall: 0.25,
  blob: 0.36,
  fish: 0.38,
  ghost: 0.28,
};

export function facingFromVector(
  dx: number,
  dy: number,
  current: WorldFacing,
): WorldFacing {
  if (Math.hypot(dx, dy) < MOVEMENT_EPSILON) return current;
  if (Math.abs(dx) > Math.abs(dy)) return dx > 0 ? 'right' : 'left';
  return dy > 0 ? 'down' : 'up';
}

export function animationStateForMovement(dx: number, dy: number): LocomotionState {
  return Math.hypot(dx, dy) < MOVEMENT_EPSILON ? 'idle' : 'walk';
}

export function footprintForPresentation(body: BodyGene, displayHeight: number): ActorFootprint {
  const height = Math.max(1, displayHeight);
  return {
    radiusX: Math.round(height * BODY_WIDTH_RATIO[body]),
    radiusY: Math.round(height * 0.15),
  };
}
